import React, { FC, useEffect, useState } from "react";
import cn from "classnames";
import styles from "./ObjectSeventhStep.module.sass";
import { IObject } from "toolkit/steps/stepSeven/stepSeven.types";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import {
	addToAttachmentList,
	changeChooseAll,
	removeFromAttachmentList,
} from "toolkit/steps/stepSeven/stepSeven.slice";
import { ModalWindow } from "components/ModalWindow/ModalWindow";
import { AssigningNumber } from "../../AssigningNumber/AssigningNumber";
import { ViewingInfo } from "../../ViewingInfo/ViewingInfo";
import ConfirmNavigate from "components/ConfirmNavigate";

interface ObjectSeventhStepProps {
	object: IObject;
	type: string;
}

export const ObjectSeventhStep: FC<ObjectSeventhStepProps> = ({ object, type }) => {
	const { attachmentMode, attachmentList, allChecked, allCheckedGlobal, excludedObjects } = useAppSelector(
		(state) => state.stepSeven,
	);
	const [checkbox, setCheckbox] = useState<boolean>(false);
	const [confirmAction, setConfirmAction] = useState<boolean>(false);
	const dispatch = useAppDispatch();
	const [modalWindow, setModalWindow] = useState<boolean>(false);

	useEffect(() => {
		if (allChecked && attachmentList.includes(object.id)) setCheckbox(true);
		else if (!allChecked && allChecked !== null) setCheckbox(false);
		//eslint-disable-next-line
	}, [allChecked, attachmentList]);

	useEffect(() => {
		if (attachmentList.includes(object.id) || (allCheckedGlobal && !excludedObjects.includes(object.id)))
			setCheckbox(true);
		//eslint-disable-next-line
	}, []);

	const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		dispatch(changeChooseAll(null));
		if (e.target.checked) dispatch(addToAttachmentList(object.id));
		else dispatch(removeFromAttachmentList(object.id));
		setCheckbox(e.target.checked);
	};

	const clickHandler = () => {
		if (attachmentMode) return;
		if (type === "repeatable") setConfirmAction(true);
		else {
			setModalWindow(true);
			setConfirmAction(false);
		}
	};

	const confirmClick = () => {
		setModalWindow(true);
		setConfirmAction(false);
	};

	return (
		<>
			{modalWindow && (
				<ModalWindow
					close={() => setModalWindow(false)}
					scroll={Boolean(object.fstekCategory && object.fstekId && object.fstekLetter?.key)}>
					{object.fstekCategory && object.fstekId && object.fstekLetter?.key ? (
						<ViewingInfo close={() => setModalWindow(false)} object={object} />
					) : (
						<AssigningNumber close={() => setModalWindow(false)} object={object} address={null} />
					)}
				</ModalWindow>
			)}
			<ConfirmNavigate toggle={confirmAction} close={() => setConfirmAction(false)} clickHandler={confirmClick} />
			<div className={styles["item-wrp"]}>
				<label
					onClick={clickHandler}
					htmlFor={`object-${object.id}`}
					className={cn(styles.item, attachmentMode && styles.label, styles[`item-${type}`])}>
					<div className={styles["label-wrp"]}>
						{attachmentMode && (
							<input
								checked={checkbox}
								onChange={changeHandler}
								type="checkbox"
								id={`object-${object.id}`}
								className={styles.checkbox}
							/>
						)}
						{/* Было */}
						{/* {attachmentMode && <input checked={checkbox} onChange={() => setCheckbox(!checkbox)} type="checkbox" id={`object-${object.id}`} className={styles.checkbox} />} */}
						<div>
							<span className={styles["item-code"]}>{object.code}</span>
							<div className={styles["item-name-wrp"]}>
								<span className={styles["item-name"]}>{object.name}</span>
							</div>
						</div>
					</div>
				</label>
			</div>
		</>
	);
};
